import { render, staticRenderFns } from "./ImageSkeleton.vue?vue&type=template&id=77d1d9ed&scoped=true&lang=pug&"
import script from "./ImageSkeleton.vue?vue&type=script&lang=js&"
export * from "./ImageSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ImageSkeleton.vue?vue&type=style&index=0&id=77d1d9ed&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1d9ed",
  null
  
)

export default component.exports